<template>
    <div class="clearfix main_center">
        <div class="right-content">
            <el-form ref="form" :model="form" label-width="180px">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>项目信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="项目名称：" size="small">
                                    {{ form.projectName }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）人：" size="small">
                                    {{ form.tendererName }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="招标（采购）项目内容：" size="small">
                                    {{ form.tenderContent }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>成交概况</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="中标单位：" size="small">
                                    {{ form.winningCompany }}
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="中标金额：" size="small">
                                    {{ form.winningAmount }} 元
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="备注信息：" size="small">
                                    {{ form.remarks }}
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {tabsCloseCurrentHandle} from '@/utils/routeTab';

export default {
    data() {
        return {
            form: {
                attachments: []
            },
        }
    },
    filters: {
        undertakeDeptFilter(status) {
            //1 工程建设部 2 政府采购部 3 资源与产权交易部
            switch (status) {
                case 1:
                    return '工程建设部';
                case 2:
                    return '政府采购部';
                case 3:
                    return '资源与产权交易部';
                default:
                    return '';
            }
        },
    },
    activated() {
        this.id = this.$route.query.id;
        this.requestDetailData();
    },
    methods: {
        //获取详情数据
        requestDetailData() {
            this.$http.get(`/bidResultSummary/get?bidResultSummaryId=${this.id}`).then(({data}) => {
                if (data.code === '1') {
                    this.form = {...data.data}
                }
            })
        },
        backBtn() { //返回
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'singleWindowServiceDealList'
            })
            this.$refs.form.resetFields();
        },
    }


}
</script>

<style lang="less" scoped>
.angle_tag {
    margin-right: 10px !important;
}
</style>
